import { GiftItem } from "../../types";
import { PosEntityGiftGroups } from "../../types";
import { mapById } from "../../Utils";
import { emptyGiftItem } from "./emptyGiftItem";
import { getMedianPrice } from "./getMedianPrice";

export const initializeGiftGroupsStateByPos = (
  payload: PosEntityGiftGroups[],
  currency: {
    en: string;
    ar: string;
  }
) => {
  const referencePos = payload.find(pos => pos.gift_groups.length > 0);
  if (!referencePos) return {};

  const referenceGroups = referencePos.gift_groups;
  const referenceGroupIds = referenceGroups.map((group) => group.id);
  const referenceGroupsById = mapById(referenceGroups, "id");

  let updatedGiftGroupsByPosId = {};

  for (const { pos_entity_id, gift_groups } of payload) {
    const currentGroupsById = mapById(gift_groups, "id");
    const allGroups = referenceGroupIds.map((groupId) => {
      const refGroup = referenceGroupsById[groupId];
      const refItems = (refGroup.items as GiftItem[]);
      if (currentGroupsById[groupId]) {
        const group = currentGroupsById[groupId];
        const currentItemsByOrder = new Map<number, GiftItem>();
        (group.items as GiftItem[]).forEach(item => {
          currentItemsByOrder.set(item.order, item);
        });
        const newItems = refItems.map(refItem => {
          const curItem = currentItemsByOrder.get(refItem.order);
          if (!curItem || Math.abs(curItem.price - refItem.price) > 0.01) {
            return {
              ...emptyGiftItem(refItem.order),
              show_price: 1,
              price: refItem.price,
              is_placeholder: 1,
            };
          } else {
            return curItem;
          }
        });
        return {
          ...group,
          ar_name: group.ar_name ?? group.name,
          is_ar_renamed: group.is_ar_renamed ?? 0,
          is_renamed: group.is_renamed ?? 0,
          items: newItems,
        };
      } else {
        const groupPrice = getMedianPrice(refItems);
        return {
          id: refGroup.id,
          name: `Gift - ${groupPrice} ${currency.en}`,
          ar_name: `هدية - ${groupPrice} ${currency.ar}`,
          is_ar_renamed: 0,
          is_renamed: 0,
          items: refItems.map((item) => ({
            ...emptyGiftItem(item.order),
            show_price: 1,
            price: item.price,
            is_placeholder: 1,
          })),
          price: groupPrice,
          is_placeholder: 1,
        };
      }
    });

    updatedGiftGroupsByPosId[pos_entity_id] = {
      ...updatedGiftGroupsByPosId[pos_entity_id],
      loading: false,
      giftGroupsIds: allGroups.map((group) => group.id),
      giftGroupsById: mapById(allGroups, "id"),
      shownGiftGroupsIds: allGroups.map((group) => group.id),
      shownGiftGroupsById: mapById(allGroups, "id"),
    };
  }

  return updatedGiftGroupsByPosId;
};
